import { useCallback, useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import AdminLogin from "@/components/AdminLogin";
import AdminDashboard from "@/components/AdminDashboard";
import AppDownload from "@/components/AppDownload";
import Kemitraan from "@/components/Kemitraan";
import Pengaduan from "@/components/Pengaduan";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Antiseptik from "@/components/Antiseptik";
import Proses from "@/components/Proses";
import Services from "@/components/Services";
import OutletFinder from "@/components/OutletFinder";
import Calculator from "@/components/Calculator";
import Pricelist from "@/components/Pricelist";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import FloatingBar from "@/components/FloatingBar";

export default function App() {
  const [outletId, setOutletId] = useState("pulomas");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const onNavigate = useCallback((e, hash) => {
    e.preventDefault();
    if (window.__lenis) window.__lenis.scrollTo(hash, { offset: -104 });
    else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const landing = (
    <div className="bg-[#FAF7FD] text-[#1E1329] font-body antialiased overflow-x-clip">
      <Navbar outletId={outletId} onNavigate={onNavigate} />
      <main>
        <Hero onNavigate={onNavigate} />
        <Marquee />
        <Manifesto />
        <Antiseptik onNavigate={onNavigate} />
        <Proses />
        <Services onNavigate={onNavigate} />
        <OutletFinder outletId={outletId} onSelect={setOutletId} />
        <Calculator outletId={outletId} />
        <Pricelist />
        <Testimonials />
        <AppDownload />
        <Kemitraan />
        <Faq />
        <Pengaduan />
      </main>
      <Footer />
      <FloatingBar outletId={outletId} />
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={landing} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
